import React, { createContext, useCallback, useMemo, useState } from "react";
import { createHttpClient } from "../api/http";
import { clearAuth, loadAuth, saveAuth } from "./authStorage";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => loadAuth());

  const getToken = useCallback(() => auth?.token || null, [auth?.token]);
  const http = useMemo(() => createHttpClient({ getToken }), [getToken]);

  const login = useCallback(
    async ({ email, password }) => {
      const res = await http.post("/api/auth/login", { email, password });
      const nextAuth = { token: res.data.token, user: res.data.user };
      setAuth(nextAuth);
      saveAuth(nextAuth);
      return nextAuth;
    },
    [http]
  );

  const logout = useCallback(() => {
    setAuth(null);
    clearAuth();
  }, []);

  const value = useMemo(
    () => ({
      auth,
      token: auth?.token || null,
      user: auth?.user || null,
      http,
      login,
      logout,
    }),
    [auth, http, login, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

